import { ReviewTypeEnum } from '../../constants/enums';
import { SET_EVALUATION_DATA, SET_MODAL_TEST_SUGGESTION_AI } from '../actionTypes';

const initialState = {
  evaluation: {
    name: '',
    startDate: {
      day: undefined,
      hours: '00:00',
    },
    endDate: {
      day: undefined,
      hours: '00:00',
    },
    language: 'es',
    allowCertificateDownload: true,
    proctoringEnabled: true,
    proctoringAIEnabled: false,
    exclusiveUsers: false,
    requireCompletedProfile: false,
    reminderToCandidates: true,
    reviewType: ReviewTypeEnum.GLOBAL,
    searchType: null,
    langCodesAISelected: [],
  },
  modalTestSuggestionAI: false,
};

function evaluationReducer(state = initialState, action) {
  switch (action.type) {
    case SET_EVALUATION_DATA: {
      return { ...state, ...action.payload };
    }
    case SET_MODAL_TEST_SUGGESTION_AI: {
      return { ...state, modalTestSuggestionAI: action.payload };
    }
    default:
      return state;
  }
}

export default evaluationReducer;
